module.exports = __webpack_public_path__ + "img/logo.64a31f87.png";